 <app-main-header [name_main]="titleheader" [goBack]="true">
    @if(creating){
        <button [disabled]="(selected_files.length === 0 && csvFile.length === 0) || !AnnotationsForm.valid" mat-flat-button
        color="primary" (click)="saveTasks()">Guardar</button>
    } @else {
    }
   
</app-main-header>
<div class="task-container">
    <div class="create-task">
        <form [formGroup]="AnnotationsForm">
            @for (d of formConfig; track d.label; let idx = $index, e = $even) {
            <mat-form-field *ngIf="d.type !== 'select'" appearance="outline"
                [ngStyle]="{ 'width': d.width, 'margin':d.margin}">
                <mat-label>{{ d.label }}</mat-label>
                <input matInput [formControlName]="d.controlName" [type]="d.type">
            </mat-form-field>
            }
        </form>
    </div>
    <ng-container *ngIf="creating; else editTask">
    <div class="upload-header">
        <h2>Imágenes</h2>
        <div class="upload-buttons">
            <button mat-raised-button class="upload-button" (click)="fileInput.click()">
                Cargar imágenes
                <input #fileInput hidden type="file" accept="image/*" multiple (change)="eventImage($event)" />
            </button>

            <button mat-raised-button class="upload-button" (click)="fileInputCsv.click()">
                Cargar CSV
                <input #fileInputCsv hidden type="file" accept=".csv" multiple (change)="eventCsv($event)" />
            </button>
        </div>
    </div>

    <div class="upload-images">
        <div class="file-preview" *ngIf="fileDisplayText">
            <mat-icon color="primary">insert_drive_file</mat-icon>
            <span>{{ fileDisplayText }}</span>
        </div>
    </div>
    </ng-container>
    <ng-template #editTask>  
    <div class="jobs-header">
      <h2>Trabajos</h2>
      <div *ngIf="jobs$ | async as jobs">
        <div *ngFor="let job of jobs" class="job-box">
          Job #{{ job.id }}
        </div>
      </div>
    </div>
  </ng-template>
</div>